<template>
  <SubpayBody/>
</template>

<script>
// @ is an alias to /src
import SubpayBody from '@/components/SubpayBody.vue'

export default {
  name: 'SubpayView',
  components: {
    SubpayBody
  }
}
</script>
